import { css } from '@emotion/react'

export const progressWrapper = css`
  display: flex;
  align-items: center;
  justify-content: center;

  height: 100%;
  width: 100%;
`
